import { AssetsProfitabilityPart } from '@/shared/lib/sj-orm/models/asset.dto';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';

import { TDtoWrapper } from '../../form-wrapper.types';

type AssetsProfitabilityHelpPart = {
  plannedDividends?: QuestionType.CURRENCY_CALCULATOR;
  actualDividends?: QuestionType.CURRENCY_CALCULATOR;
  dividendsDelta?: QuestionType.NUMBER;
  independentAppraisalAmount?: QuestionType.CURRENCY_CALCULATOR;
  availableLimit?: QuestionType.CURRENCY_CALCULATOR;
  expenses?: QuestionType.CURRENCY_CALCULATOR;
  buyingPrice?: QuestionType.CURRENCY_CALCULATOR;
  strikePrice?: QuestionType.CURRENCY_CALCULATOR;
};

export type AssetsProfitabilityPartType = TDtoWrapper<
  AssetsProfitabilityPart,
  AssetsProfitabilityHelpPart
>;

const AssetsProfitabilityFormPartFull: AssetsProfitabilityPartType = {
  plannedDividends: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:legalEntity.inputs.expectedDividends.label',
    tooltip: 'forms_assets:common.inputs.purchaseValue.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 1,
  },
  actualDividends: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:legalEntity.inputs.actualDividends.label',
    tooltip: 'forms_assets:common.inputs.purchaseValue.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 2,
  },
  dividendsDelta: {
    type: QuestionType.NUMBER,
    label: 'forms_assets:legalEntity.inputs.dividendsDelta.label',
    tooltip: 'forms_assets:legalEntity.inputs.dividendsDelta.tooltip',
    order: 3,
  },
  independentAppraisalAmount: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:jewelery.inputs.independentAppraisalAmount.label',
    tooltip: 'forms_assets:common.inputs.purchaseValue.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 4,
    value: 0,
  },
  availableLimit: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:brokerageAccount.inputs.availableLimit.label',
    tooltip: 'forms_assets:brokerageAccount.inputs.availableLimit.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 5,
  },
  expenses: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:brokerageAccount.inputs.expenses.label',
    order: 6,
  },
  buyingPrice: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:exchangeOptions.inputs.buyingPrice.label',
    tooltip: 'forms_assets:exchangeOptions.inputs.buyingPrice.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 7,
  },
  strikePrice: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:exchangeOptions.inputs.strikePrice.label',
    tooltip: 'forms_assets:exchangeOptions.inputs.strikePrice.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    order: 8,
  },
};

export const assetsProfitabilityBuilder = (
  includeItems: Array<keyof AssetsProfitabilityHelpPart> = [],
) =>
  Object.entries(AssetsProfitabilityFormPartFull).reduce<AssetsProfitabilityPartType>(
    (acc, [key, value]) => {
      const field = key as keyof AssetsProfitabilityHelpPart;

      if (includeItems.includes(field)) {
        // TODO: refactor form-wrapper.types.ts
        // @ts-ignore
        acc[field] = value as AssetsProfitabilityPartType[keyof AssetsProfitabilityHelpPart];
      }

      return acc;
    },
    {},
  );
